import AdminUsers from "./users";
import AdminCollects from "./collects";

export const AdminUsersPage = AdminUsers;
export const AdminCollectsPage = AdminCollects;

